import { createContext } from 'react'
import type { ThemeContextType } from '../model'

export const ThemeContext = createContext<ThemeContextType | undefined>(
    undefined
)
